<template>
    <custom-dialog width="1230px" :showClose="true" title="" v-if="visibleObj.dataDoardDialog"
        :visible="visibleObj.dataDoardDialog" @close="dialogVisible('dataDoardDialog')">
        <div slot="header" class="header">
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="changeTab">
                <el-menu-item index="1">挂号明细</el-menu-item>
                <el-menu-item index="2">门诊明细</el-menu-item>
                <el-menu-item index="3">业绩明细</el-menu-item>
            </el-menu>
            <!-- <el-select v-if="!doctorId" class="doctor-select" v-model="doctorId" placeholder="请选择">
                <el-option v-for="item in doctorOptions" :key="item.doctorId" :label="item.doctorName"
                    :value="item.doctorId">
                </el-option>
            </el-select> -->
            <i @click="dialogVisible('dataDoardDialog')" class="el-icon-close"></i>
        </div>
        <div slot="content" class="content">
            <div class="content-top">
                <el-radio-group v-model="dateType" @input="changeDateType">
                    <el-radio-button :label="1">今天</el-radio-button>
                    <el-radio-button :label="6">明天</el-radio-button>
                    <el-radio-button :label="7">后天</el-radio-button>
                    <el-radio-button :label="2">昨天</el-radio-button>
                    <el-radio-button :label="3">本周</el-radio-button>
                    <el-radio-button :label="4">本月</el-radio-button>
                    <el-radio-button :label="5">上月</el-radio-button>
                </el-radio-group>
                <div class="ml16">
                    <el-date-picker @change="datePickChange" v-model="dateRange" type="daterange"
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                    </el-date-picker>
                </div>
            </div>
            <!-- 挂号明细 -->
            <div v-if="activeIndex == 1">
                <div class="content-status">
                    <div class="status-item" :class="registerSearchFrom.status == item.value ? 'active' : ''"
                        @click="statusChange(item.value)" v-for="item in registerStatusList" :key="item.value">
                        <div class="item-title">
                            <div :style="{ background: item.color }" class="icon"></div>
                            <div>{{ item.label }}</div>
                            <el-tooltip v-if="item.value == '123'" content="已约号数=待签到+待就诊+已就诊" placement="top"
                                effect="light">
                                <i class="el-icon-question color9AA0 ml5"></i>
                            </el-tooltip>
                        </div>
                        <div class="item-content">
                            <div class="content-num">
                                <div class="color6671">号数</div>
                                <div class="color1F23"><span class="item-num">{{ item.num }}</span> 个</div>
                            </div>
                            <div class="content-money">
                                <div class="color6671">挂号费</div>
                                <div class="color1F23">¥ <span class="item-num">{{ item.money || 0 }}</span> </div>
                                <div v-if="['123', '2', '3'].includes(item.value)" style="transform: translateY(-3px);">(含{{item.notPayMoney || 0}}待收)</div>
                            </div>
                        </div>
                        <!-- <div class="mt12">号数 <span class="item-num">{{ item.num }}</span></div>
                        <div class="mt12">挂号费 <span class="item-num">¥{{ item.money }}</span></div> -->
                    </div>
                </div>
                <div class="custom-table">
                    <div class="display-f color6671">
                        <div>初诊：<span class="color0000 fwb">{{ registerCountObj.firstDoctorVisitNum }}</span> 人</div>
                        <div class="ml10">复诊：<span class="color0000 fwb">{{ registerCountObj.manyDoctorVisitNum }}</span> 人
                        </div>
                    </div>
                    <customTable height="320" @pageChange="registerPageChange" class="customTable mt8"
                        :tableData="registerTableData" :column="registerColumn" :total="registerTotal"
                        :currentPage="registerSearchFrom.pageNum" :header-cell-style="{ background: '#F0F1F3' }">
                        <template slot="type" slot-scope="{ row }">
                          <div style="display: flex;flex-wrap: nowrap;">
                            {{dictText(row.type, outpatientTypeList)}}
                          </div>
                        </template>
                        <template slot="price" slot-scope="{ row }">
                          <div style="display: flex;flex-wrap: nowrap;">
                            <div>￥{{ isNull(row.finalPrice) ? '0' : + row.finalPrice }}</div>
                            <div v-if="row.registerStatus === '5'" style="padding: 0px 6px;font-size: 12px;color: #FE8F1F;background-color: rgba(254, 143, 31, .1);border-radius: 2px;">待收</div>
                          </div>
                        </template>
                        <template slot="registeredCode" slot-scope="{ row }">
                            <div>{{ row.timeName }}{{ row.registeredCode || '-' }}</div>
                        </template>
                        <template slot="status" slot-scope="{ row } ">
                            <div v-for="item in registerStatusList" :key="item.value">
                                <div v-if="item.value == row.orderStatus" :style="{ color: item.color }"> {{ row.orderStatus |
                                    filterRegisterStatus(that) }}</div>
                            </div>
                        </template>
                        <!-- 签到 --> 
                        <template slot="qianDao" slot-scope="{ row }">
                          <!-- 如果未签到并且已退费 则不显示签到图标 -->
                          <!-- signStatus 0：未签到 1：已签到 -->
                          <div v-if="!(row.signStatus == 0 && row.orderStatus == -3)">
                            <img v-if="[2, 3, 5, -3].includes(row.orderStatus)" style="margin-top: 4px;width: 16px;" :src="imgArr.greenMark" alt="">
                            <img v-if="[1].includes(row.orderStatus)" style="margin-top: 4px;width: 16px;" :src="imgArr.grayMark" alt="">
                          </div>
                        </template>
                        <!-- 就诊 visitStatus 0 代表待诊断 1代表已诊-->
                        <template slot="jiuZhen" slot-scope="{ row }">
                          <!-- 如果是未就诊并且已退费 则不显示就诊图标 -->
                          <div v-if="!([0].includes(row.visitStatus) && row.orderStatus == -3)">
                            <img v-if="[1].includes(row.visitStatus)" style="margin-top: 4px;width: 16px;" :src="imgArr.greenMark" alt="">
                            <img v-if="[0].includes(row.visitStatus)" style="margin-top: 4px;width: 16px;" :src="imgArr.grayMark" alt="">
                          </div>
                        </template>
                        <!-- 收费 -->
                        <template slot="shouFei" slot-scope="{ row }">
                          <!-- 通过划价单的状态判断 -->
                          <!-- orderPaymentPayStatus：0-未支付,1-已支付,2-已退款 -->
                          <!-- orderStatus: -3:已退 -->
                          <!-- 如果是划价单已退费或者订单已退费则不显示收费图标 -->
                          <div v-if="!(row.orderPaymentPayStatus == 2 || row.orderStatus == -3)">
                            <img v-if="[1].includes(row.orderPaymentPayStatus)" style="margin-top: 4px;width: 16px;" :src="imgArr.greenMark" alt="">
                            <img v-else style="margin-top: 4px;width: 16px;" :src="imgArr.grayMark" alt="">
                          </div>
                        </template>
                    </customTable>
                </div>
            </div>
            <!-- 门诊明细 -->
            <div v-if="activeIndex == 2">
                <div class="content-status">
                    <div class="status-item" @click="statusChange(item.value)"
                        :class="outpatientSearchFrom.status == item.value ? 'active' : ''"
                        v-for="item in outpatientStatusList" :key="item.value">
                        <div class="item-title">
                            <div :style="{ background: item.color }" class="icon"></div>
                            <div>{{ item.label }}</div>
                            <el-tooltip v-if="item.value == '9'" content="收费员未收取该费用，并关闭了收费单" placement="top" effect="light">
                                <i class="el-icon-question color9AA0 ml5"></i>
                            </el-tooltip>
                        </div>
                        <div class="mt7 tac"> <span class="color1F23 size28 fwb">{{ item.num }}</span> 人</div>
                        <div class="color6671 tac mt8">人数合计</div>
                    </div>
                </div>
                <div class="custom-table">
                    <div class="display-f color6671">
                        <div>初诊：<span class="color0000">{{ outpatientCountObj.firstDoctorVisitNum }}</span> 人</div>
                        <div class="ml10">复诊：<span class="color0000">{{ outpatientCountObj.manyDoctorVisitNum }}</span> 人
                        </div>
                        <div class="ml10">处方量：<span class="color0000">{{ outpatientCountObj.recipeNum }}</span> </div>
                        <div class="ml10">实收费用合计：<span class="color0000">¥{{ outpatientCountObj.realIncomeMoney }}</span> </div>
                    </div>
                    <customTable height="320" @pageChange="outpatientPageChange" class="customTable mt8"
                        :tableData="outpatientTableData" :column="outpatientColumn" :total="outpatientTotal"
                        :currentPage="outpatientSearchFrom.currentPage" :header-cell-style="{ background: '#F0F1F3' }">
                        <template slot="orderScheduleNum" slot-scope="{ row } ">
                            <div>{{ row.timeName }}{{ row.orderScheduleNum || '-' }}</div>
                        </template>
                        <template slot="status" slot-scope="{ row } ">
                            <div v-for="item in chargeStatusList" :key="item.value">
                                <div v-if="item.value == row.status" :style="{ color: item.fontColor }"> {{ row.status |
                                    filterOutpatientStatus }}</div>
                            </div>
                        </template>
                    </customTable>
                </div>
            </div>
            <!-- 业绩明细 -->
            <div v-if="activeIndex == 3">
              <div class="achievement">
                <div class="achievement-item">
                  <div class="achievement-item-title">挂号费</div>
                  <div class="achievement-item-list">
                    <div class="achievement-item-list-item achievement-item-total">
                      <span>合计</span>
                      <span>￥{{ achievementOfGuaHaoInfo.guaHaoTotalPay || 0 }}</span>
                    </div>
                  </div>
                  <div class="achievement-item-list">
                    <div class="achievement-item-list-item">
                      <span>待签</span>
                      <span>￥{{ achievementOfGuaHaoInfo.staySignAmount || 0 }}</span>
                    </div>
                    <div class="achievement-item-list-item">
                      <span>待诊</span>
                      <span>￥{{ achievementOfGuaHaoInfo.staySeeAmount || 0 }}</span>
                    </div>
                    <div class="achievement-item-list-item">
                      <span>已诊</span>
                      <span>￥{{ achievementOfGuaHaoInfo.alreadySeeAmount || 0 }}</span>
                    </div>
                  </div>
                </div>
                <div class="achievement-item">
                  <div class="achievement-item-title">销售额</div>
                  <div class="achievement-item-list">
                    <div class="achievement-item-list-item achievement-item-total">
                      <span>合计</span>
                      <span>￥{{ achievementInfo.achievementTotalPay || 0 }}</span>
                    </div>
                  </div>
                  <div class="achievement-item-list">
                    <div class="achievement-item-list-item">
                      <span>中药饮片</span>
                      <span>￥{{ achievementInfo.medicinePieces || 0 }}</span>
                    </div>
                    <div class="achievement-item-list-item">
                      <span>中药颗粒</span>
                      <span>￥{{ achievementInfo.medicineGrain || 0 }}</span>
                    </div>
                    <div class="achievement-item-list-item">
                      <span>中成药</span>
                      <span>￥{{ achievementInfo.chinesePatentDrugPay || 0 }}</span>
                    </div>
                    <div class="achievement-item-list-item">
                      <span>理疗项目</span>
                      <span>￥{{ achievementInfo.physioPay || 0 }}</span>
                    </div>
                    <div class="achievement-item-list-item">
                      <span>加工费-熬药</span>
                      <span>￥{{ achievementInfo.decoctHerbsPay || 0 }}</span>
                    </div>
                    <div class="achievement-item-list-item">
                      <span>加工费-制膏</span>
                      <span>￥{{ achievementInfo.creamMakingPay || 0 }}</span>
                    </div>
                    <div class="achievement-item-list-item">
                      <span>加工费-制丸</span>
                      <span>￥{{ achievementInfo.pillPay || 0 }}</span>
                    </div>
                    <div class="achievement-item-list-item">
                      <span>加工费-打粉</span>
                      <span>￥{{ achievementInfo.powderPay || 0 }}</span>
                    </div>
                    <div class="achievement-item-list-item">
                      <span>加工费-加工YL</span>
                      <span>￥{{ achievementInfo.comboPay || 0 }}</span>
                    </div>
                    <div class="achievement-item-list-item">
                      <span>快递费</span>
                      <span>￥{{ achievementInfo.deliveryPricePay || 0 }}</span>
                    </div>
                    <div class="achievement-item-list-item">
                      <span>医疗器械</span>
                      <span>￥{{ achievementInfo.medicalDevicePay || 0 }}</span>
                    </div>
                    <div class="achievement-item-list-item">
                      <span>后勤材料</span>
                      <span>￥{{ achievementInfo.logisticsMaterialPay || 0 }}</span>
                    </div>
                    <div class="achievement-item-list-item">
                      <span>保健食品</span>
                      <span>￥{{ achievementInfo.healthFoodPay || 0 }}</span>
                    </div>
                    <div class="achievement-item-list-item">
                      <span>其他商品</span>
                      <span>￥{{ achievementInfo.otherGoodsPay || 0 }}</span>
                    </div>
                    <div class="achievement-item-list-item">
                      <span>未分类</span>
                      <span>￥{{ achievementInfo.notClassifiedPay || 0 }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <div slot="footer"></div>
    </custom-dialog>
</template>
  
<script>
import { imgArr } from "@/assets/images/img.js";
import CustomDialog from '@/components/customDialog/CustomDialog'
import { Outpatient } from '../data/index'
import { Utils } from '@/utils/utils'
import customTable from '@/components/customTable/customTable'
import { outpatientTypeList, chargeStatusList, orderSourceTypeList } from '@/utils/const'
import { dictText, isNull,debounce } from '@/utils/validateBase'
import { doctorDTO } from '@/DTO/index'
export default {
    // 定义引入的组件
    components: { CustomDialog, customTable },
    props: {
        visibleObj: {
            type: Object,
            default: () => { return {} }
        },
        dialogObj: {
            type: Object,
            default: () => { return {} }
        },
    },
    data() {
        return {
            outpatientTypeList,
            dictText,
            isNull,
            imgArr,
            that: this,
            activeIndex: '1',
            dateType: 1,
            doctorId: '',
            doctorUserCode: '',
            doctorOptions: [],
            chargeStatusList,
            orderSourceTypeList: orderSourceTypeList,//就诊类型
            outpatientSearchFrom: {
                deptId: this.$session.get('deptId'),
                status: '0',//0-已诊人数，8-待收费，4-已收费，-7-已退费，9-已关闭
                pageSize: 10,
                currentPage: 1,
                deptId: this.$session.get('deptId'),
            },//门诊搜索对象
            registerSearchFrom: {
                status: '123',
                pageSize: 10,
                pageNum: 1,
                deptId: this.$session.get('deptId'),
            },//挂号搜索对象
            dateRange: [],//时间范围
            //挂号状态
            registerStatusList: [
                { label: '已约', value: '123', num: '', money: '', notPayMoney: '', color: '#2363DE' },
                { label: '待签', value: '1', num: '', money: '', color: '#FE8F1F' },
                { label: '待诊', value: '2', num: '', money: '', notPayMoney: '', color: '#1890FF' },
                { label: '已诊', value: '3', num: '', money: '', notPayMoney: '', color: '#29C01B' },
                { label: '已退', value: '-3', num: '', money: '', color: '#9AA0A8' },
            ],
            //门诊状态
            outpatientStatusList: [
                { label: '已诊', value: '0', num: '', money: '', color: '#29C01B' },
                { label: '待收', value: '8', num: '', money: '', color: '#FE8F1F' },
                { label: '已收', value: '4', num: '', money: '', color: '#1890FF' },
                { label: '已退', value: '-7', num: '', money: '', color: '#9AA0A8' },
                { label: '关闭', value: '9', num: '', money: '', color: '#9AA0A8' },
            ],
            registerTotal: 0,//总数
            outpatientTotal: 0,//总数
            registerTableData: [],//挂号表格数据
            outpatientTableData: [],//门诊表格数据
            //挂号表头数据
            registerColumn: [
                { type: 'index', label: '序号', width: '48' },
                { label: '患者', prop: 'patientName', align: "left", width: '90' },
                { label: '性别', prop: 'sex', formatter: (row) => { return row.sex == '0' ? '男' : '女' }, align: "left", width: '48' },
                { label: '年龄', prop: 'age', formatter: (row) => { return  `${row.age}岁${isNull(row.ageMth) ? '' : `${row.ageMth}月` }` }, align: "left", width: '88' },
                { label: '手机号码', prop: 'phone', align: "left", width: '120' },
                { label: '患者类型', prop: 'doctorVisit', formatter: (row) => { return isNull(row.doctorVisit) ? '' : row.doctorVisit == '1' ? '复诊' : '初诊' }, align: "left", width: '70' },
                { label: '门诊类型', prop: 'type', slotName: 'type', align: "left", width: 90,showOverflowTooltip: true },
                { label: '挂号费', slotName:'price', align: "left", width: '100' },
                { label: '优惠券', prop:'couponPrice', align: "left", width: '65' },
                { label: '预约日期', prop: 'schedulingTime', align: "left", width: '100' },
                { label: '预计就诊时间', prop: 'timeQuantumName', formatter: (row) => { return isNull(row.timeQuantumName) ? '-' : `${row.timeQuantumName}` }, align: "left", width: '120' },
                { label: '号数', slotName: 'registeredCode', align: "left", width: '70',showOverflowTooltip: true },
                { label: '状态', slotName: 'status', align: "left", width: '48' },
                { label: '签到', slotName: 'qianDao', align: "left", width: '48' },
                { label: '就诊', slotName: 'jiuZhen', align: "left", width: '48' },
                { label: '收费', slotName: 'shouFei', align: "left", width: '48' },
            ],
            //挂号统计对象
            registerCountObj: {},
            //门诊表头数据
            outpatientColumn: [
                { type: 'index', label: '序号' },
                { label: '患者', prop: 'patientName', align: "left" },
                { label: '性别', prop: 'sex', formatter: (row) => { return row.sex == '0' ? '男' : '女' }, align: "left", width: '60' },
                { label: '手机号码', prop: 'phone', align: "left" },
                { label: '初复诊', prop: 'doctorVisit', formatter: (row) => { return isNull(row.doctorVisit) ? '' : row.doctorVisit == '1' ? '复诊' : '初诊' }, align: "left" },
                { label: '就诊来源', prop: 'orderSourceType', formatter: (row) => { return dictText(row.orderSourceType, orderSourceTypeList) }, align: "left" },
                { label: '实收费用', prop: 'realPay', formatter: (row) => { return isNull(row.realPay) ? '-' : `¥${row.realPay}` }, align: "left" },
                { label: '预约日期', prop: 'schedulingTime', align: "left" },
                { label: '号数', slotName: 'orderScheduleNum', align: "left"},
                { label: '状态', slotName: 'status', align: "left" },
            ],
            //门诊统计对象
            outpatientCountObj: {},
            // 业绩明细-挂号费
            achievementOfGuaHaoInfo: {},
            // 业绩明细-销售额
            achievementInfo: {}
        }
    },
    //变量监听
    watch: {},
    filters: {
        filterOutpatientStatus(val) {
            return dictText(val, chargeStatusList)
        },
        filterRegisterStatus(val, that) {
            return dictText(val, that.registerStatusList)
        },
    },
    // 页面初始化
    created() {
        this.doctorId = this.dialogObj.doctorId
        this.doctorUserCode = this.dialogObj.doctorUserCode
        this.outpatientSearchFrom.doctorId = this.doctorId
        this.registerSearchFrom.doctorId = this.doctorId
        this.getDoctorList()
        if (this.activeIndex == 1) {
          this.registerPost()
        } else if (val == 2) {
          this.outpatientPost()
        } else {
          this.getAchievementData()
        }
    },
    // 页面DOM加载完成
    mounted() { },
    //离开页面时执行
    destroyed() { },
    // 页面方法
    methods: {
        /**
         * 挂号明细请求
         */
        registerPost() {
            this.getRegisterPanelList()
            this.getPanelCount()
            this.getPanelListCensus()
        },
        /**
         * 门诊明细请求
         */
        outpatientPost() {
            this.getPanel()
            this.getDoorPage()
        },
        /**
         * 业绩明细请求
         */
        getAchievementData() {
          this.getPanelCount()
          this.getAchievementXiaoShou()
        },
        /**
         * 关闭
        */
        dialogVisible(name) {
            this.$emit("close", name);
        },
        /**
         * 切换tab
         */
        changeTab:debounce(function(val){
          this.activeIndex = val
          this.registerSearchFrom.pageNum = 1
          this.outpatientSearchFrom.currentPage = 1
          if (val == 1) {
            this.registerPost()
          } else if (val == 2) {
            this.outpatientPost()
          } else {
            this.getAchievementData()
          }
        },700,true),
        /**
         * 计算选择时间的时间戳
         */
        computeDate() {
            let lastMon = this.$moment().subtract(1, 'months')
            let nowDay = this.$moment()
            let yesterday = this.$moment().subtract(1, 'days')
            const tomorrow = this.$moment().add(1, 'days')
            const tomorrowNextDay = this.$moment().add(2, 'days')
            let startDate = ''
            let endDate = ''
            switch (this.dateType) {
                case 1: //今天
                    startDate = Utils.startOfDay(nowDay)
                    endDate = Utils.endOfDay(nowDay)
                    break;
                case 2: //昨天
                    startDate = Utils.startOfDay(yesterday)
                    endDate = Utils.endOfDay(yesterday)
                    break;
                case 3: //本周
                    startDate = Utils.startOfDay(this.$moment().startOf('isoWeek'))
                    endDate = Utils.endOfDay(this.$moment().endOf('isoWeek'))
                    break;
                case 4: //本月
                    startDate = Utils.startOfDay(this.$moment().startOf('month'))
                    endDate = Utils.endOfDay(this.$moment().endOf('month'))
                    break;
                case 5: //上月
                    startDate = Utils.startOfDay(this.$moment(lastMon).startOf('month'))
                    endDate = Utils.endOfDay(this.$moment(lastMon).endOf('month'))
                    break;
                case 6: //明天
                    startDate = Utils.startOfDay(tomorrow)
                    endDate = Utils.endOfDay(tomorrow)
                    break;
                case 7: //后天
                    startDate = Utils.startOfDay(tomorrowNextDay)
                    endDate = Utils.endOfDay(tomorrowNextDay)
                    break;
                case 999: //自定义
                    startDate = Utils.startOfDay(this.dateRange[0])
                    endDate = Utils.endOfDay(this.dateRange[1])
                    break;
            }
            return { startDate, endDate }
        },
        /**
         * 切换时间
         */
        changeDateType:debounce(function(val){
          {
            this.dateRange = []
            if (val == 999) return
            if (this.activeIndex == 1) {
              this.registerSearchFrom.pageNum = 1
              this.registerPost()
            } else if (this.activeIndex == 2) {
              this.outpatientSearchFrom.currentPage = 1
              this.outpatientPost()
            } else {
              this.getAchievementData()
            }
        }
        },700,true),
        /**
         * 查询门诊统计信息
         */
        async getPanel() {
            let { startDate, endDate } = this.computeDate()
            this.outpatientSearchFrom.startTime = startDate
            this.outpatientSearchFrom.endTime = endDate
            let { code, data } = await Outpatient.getPanel(this.outpatientSearchFrom)
            if (code == 200) {
                this.outpatientCountObj = data
                this.outpatientStatusList.forEach(item => {
                    switch (item.value) {
                        case '0':
                            item.num = data.finishSeeNum
                            item.money = data.finishSeeMoney
                            break;
                        case '8':
                            item.num = data.waitPayNum
                            item.money = data.waitPayMoney
                            break;
                        case '4':
                            item.num = data.finishPayNum
                            item.money = data.finishPayMoney
                            break;
                        case '-7':
                            item.num = data.refundNum
                            item.money = data.refundMoney
                            break;
                        case '9':
                            item.num = data.closeNum
                            item.money = data.closeMoney
                            break;
                    }
                })
            }
        },
        /**
         * 页码改变
         */
        outpatientPageChange(obj) {
            let { current, size } = obj
            this.outpatientSearchFrom.currentPage = current
            this.outpatientSearchFrom.pageSize = size
            this.getDoorPage()
        },
        /**
         * 页码改变
         */
        registerPageChange(obj) {
            let { current, size } = obj
            this.registerSearchFrom.pageNum = current
            this.registerSearchFrom.pageSize = size
            this.getRegisterPanelList()
        },
        /**
         * 获取门诊分页信息
         */
        async getDoorPage() {
            let { startDate, endDate } = this.computeDate()
            this.outpatientSearchFrom.startTime = startDate
            this.outpatientSearchFrom.endTime = endDate
            let { code, rows, total } = await Outpatient.getDoorPage(this.outpatientSearchFrom)
            if (code == 200) {
              const typeInfo = {
                '1': '上午',
                '2': '中午',
                '3': '下午',
                '4': '晚上',
                '5': '全天',
              }
              this.outpatientTableData = rows.map(item => ({
                ...item,
                timeName: typeInfo[item.type]
              }))
              this.outpatientTotal = total
            }
        },
        // 获取业绩明细销售额
        getAchievementXiaoShou:debounce(async function(){
          const { startDate, endDate } = this.computeDate()
          const params = {
              startTime: startDate,
              stopTime: endDate,
              deptId: this.$session.get('deptId'),
              salesPersonCode: this.doctorUserCode || ''
          }
          try {
            const res = await Outpatient.achievement(params)
            if(res.code == 200) {
              const achievementInfo = res.data || {}
              const achievementInfoObj = {
                // 中药饮品
                medicinePieces: this.$bigNumber(achievementInfo.piecePay, '+' , achievementInfo.pieceYlPay) || 0,
                // 中药颗粒
                medicineGrain: this.$bigNumber(achievementInfo.particlePay, '+' , achievementInfo.particleYlPay) || 0,
                // 中成药
                chinesePatentDrugPay: achievementInfo.chinesePatentDrugPay || 0,
                // 理疗项目
                physioPay: achievementInfo.physioPay || 0,
                // 加工费-熬药
                decoctHerbsPay: achievementInfo.decoctHerbsPay || 0,
                // 加工费-制膏
                creamMakingPay: achievementInfo.creamMakingPay || 0,
                // 加工费-制丸
                pillPay: achievementInfo.pillPay || 0,
                // 加工费-打粉
                powderPay: achievementInfo.powderPay || 0,
                // 加工费-加工YL
                comboPay: achievementInfo.comboPay || 0,
                // 快递费
                deliveryPricePay: achievementInfo.deliveryPricePay || 0,
                // 医疗器械
                medicalDevicePay: achievementInfo.medicalDevicePay || 0,
                // 后勤材料
                logisticsMaterialPay: achievementInfo.logisticsMaterialPay || 0,
                // 保健食品
                healthFoodPay: achievementInfo.healthFoodPay || 0,
                // 其他商品
                otherGoodsPay: achievementInfo.otherGoodsPay || 0,
                // 未分类
                notClassifiedPay: achievementInfo.notClassifiedPay || 0
              }

              let achievementTotalPay = 0
              for (let key in achievementInfoObj) {
                achievementTotalPay = this.$bigNumber(achievementTotalPay, '+', achievementInfoObj[key])
              }

              this.achievementInfo = {
                ...achievementInfoObj,
                achievementTotalPay
              }
            }
          } catch (error) {
            console.log('获取业绩明细销售额数据失败', error)
          }
        },700,true),
        
        /**
         * 时间输入改变
         */
        datePickChange() {
            this.dateType = 999
            if (this.activeIndex == 1) {
                this.registerPost()
            } else if (this.activeIndex == 2) {
                this.outpatientPost()
            } else {
              this.getAchievementData()
            }
        },
        /**
         * 获取挂号看板数量
         */
        async getPanelCount() {
            let { deptId } = this.registerSearchFrom
            let { startDate, endDate } = this.computeDate()
            let params = {
                doctorId: this.doctorId,
                deptId,
                startTime: startDate,
                stopTime: endDate
            }
            let { code, data } = await Outpatient.getPanelCount(params)
            if (code == 200) {
              if(this.activeIndex == 1) {
                // 挂号明细-挂号看板
                this.registerStatusList.forEach(item => {
                    switch (item.value) {
                        case '123':
                            let tem = this.$bigNumber(data.staySignNum, '+', data.staySeeNum)
                            item.num = this.$bigNumber(tem, '+', data.alreadySeeNum) //已约号数=待签到+待就诊+已就诊
                            let tmpTotal = this.$bigNumber(data.staySignAmount, '+', data.staySeeAmount)
                            item.money = this.$bigNumber(tmpTotal, '+', data.alreadySeeAmount)
                            // 还未收费的补录挂号
                            item.notPayMoney = data.recipeTotalStaySeeAmount
                            break;
                        case '1':
                            item.num = data.staySignNum
                            item.money = data.staySignAmount
                            break;
                        case '2':
                            item.num = data.staySeeNum
                            item.money = data.staySeeAmount             
                            // 还未收费的补录挂号费用
                            item.notPayMoney = data.recipeStaySeeAmount
                            break;
                        case '3':
                            item.num = data.alreadySeeNum
                            item.money = data.alreadySeeAmount                            
                            // 还未收费的补录挂号费用
                            item.notPayMoney = data.recipeStayPayAmount
                            break;
                        case '-3':
                            item.num = data.refundNum
                            item.money = data.refundAmount
                            break;
                    }
                })
              } else if (this.activeIndex == 3) {
                // 业绩明细-挂号费
                const achievementOfGuaHaoInfo = {
                  // 待签
                  staySignAmount: data.staySignAmount || 0,
                  // 待诊
                  staySeeAmount: data.staySeeAmount || 0,
                  // 已诊
                  alreadySeeAmount: data.alreadySeeAmount || 0
                }
                let guaHaoTotalPay = 0
                for (let key in achievementOfGuaHaoInfo) {
                  guaHaoTotalPay = this.$bigNumber(guaHaoTotalPay, '+', achievementOfGuaHaoInfo[key])
                }

                this.achievementOfGuaHaoInfo = {
                  ...achievementOfGuaHaoInfo,
                  guaHaoTotalPay
                }
              }
            }
        },
        /**
         * 分页获取挂号看板
         */
        async getRegisterPanelList() {
            let status = []
            let { startDate, endDate } = this.computeDate()
            let params = { ...this.registerSearchFrom, startTime: startDate, stopTime: endDate }
            if (this.registerSearchFrom.status == '123') {
              // 已约
                status = ['1', '2', '3', '5']
            } else if (this.registerSearchFrom.status == '2') {
              // 待诊
                status = ['2', '5']
            } else if (this.registerSearchFrom.status == '3') {
              // 已诊
                status = ['3', '5']
            } else {
                status[0] = this.registerSearchFrom.status
            }
            params.status = status
            let { code, rows, total } = await Outpatient.getRegisterPanelList(params)
            if (code == 200) {
                this.registerTableData = rows
                this.registerTotal = total
            }
        },
        /**
         * 获取挂号看板list统计
         */
        async getPanelListCensus() {
            let status = []
            let { deptId } = this.registerSearchFrom
            let { startDate, endDate } = this.computeDate()
            let params = {
                doctorId: this.doctorId,
                deptId,
                startTime: startDate,
                stopTime: endDate
            }
            if (this.registerSearchFrom.status == '123') {
              // 已约
                status = ['1', '2', '3', '5']
            } else if (this.registerSearchFrom.status == '2') {
              // 待诊
                status = ['2', '5']
            } else if (this.registerSearchFrom.status == '3') {
              // 已诊
                status = ['3', '5']
            } else {
                status[0] = this.registerSearchFrom.status
            }
            params.status = status
            let { code, data } = await Outpatient.getPanelListCensus(params)
            if (code == 200) {
                this.registerCountObj = data
            }
        },
        /**
         * 状态切换
         */
        statusChange(val) {
            if (this.activeIndex == 1) {
                this.registerSearchFrom.pageNum=1
                this.registerSearchFrom.status = val
                this.registerPost()
            } else {
                this.outpatientSearchFrom.currentPage=1
                this.outpatientSearchFrom.status = val
                this.outpatientPost()
            }

        },
        // 请求排班医生列表
        async getDoctorList() {
            let { rows, code } = await doctorDTO.queryDoctorDept({ deptId: this.$session.get('deptId'), pageNum: 1, pageSize: 100 });
            if (code == 200) rows.forEach(item => {
                this.doctorOptions.push({ doctorName: item.doctorName, doctorId: item.doctorId });
            });
        },
    },
}
</script>
<style lang="less" scoped>
/deep/.pagination-wrap {
    padding-bottom: 0;
}

.is-active {
    font-weight: 600;
}

.header {
    position: relative;

    .doctor-select {
        position: absolute;
        top: 15px;
        left: 210px;
    }

    .el-icon-close {
        position: absolute;
        top: 20px;
        right: 16px;
        font-size: 20px;
    }

}

.content {
    .content-top {
        display: flex;
        align-items: center;
    }

    .content-status {
        display: flex;
        margin-top: 16px;

        .status-item {
            width: 216px;
            height: 106px;
            padding: 12px;
            box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.12);
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #EBEAEE;
            box-sizing: border-box;
            font-size: 14px;
            color: #667182;
            margin-right: 8px;

            &:last-child {
                margin-right: 0;
            }

            &:hover {
                border-color: #1890FF;
            }

            .item-title {
                color: #1F2329;
                font-weight: 500;
                font-size: 16px;
                display: flex;

                .icon {
                    width: 3px;
                    height: 14px;
                    margin-right: 4px;
                }
            }

            .item-content {
                display: flex;
                margin-top: 10px;

                .content-num {
                    width: 64px;
                    height: 42px;
                    border-right: 1px solid #DBDEE2;
                }

                .content-money {
                    padding-left: 12px;
                }
            }

            .item-num {
                color: #1F2329;
                font-size: 22px;
                font-weight: 500;
                text-align: left;
                line-height: 33px;
            }
        }

        .active {
            border-color: #1890FF;
            background: #E8F4FF;
        }
    }

    .custom-table {
        color: #1F2329;
        margin-top: 16px;
    }

    // 业绩明细
    .achievement {
      padding-bottom: 50px;
      &-item {
        &-title {
          margin: 16px 0;
          padding-left: 6px;
          border-left: 3px solid #1890FF;
          font-weight: 600;
        }
        &-list {
          display: grid;
          grid-template-columns: repeat(5, 210px);
          grid-gap: 12px;
          &-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px;
            box-sizing: border-box;
            width: 210px;
            height: 48px;
            background: #FFFFFF;
            border-radius: 2px;
            border: 1px solid #EBEAEE;
            cursor: pointer;
            &:hover{
              border: 1px solid #1890FF!important;
            }
            span:nth-child(1) {
              color: #667182;
            }
            span:nth-child(2) {
              font-weight: 600;
            }
          }
          .achievement-item-total {
            margin-bottom: 12px;
            background-color: #E8F4FF;
            border: 1px solid #EBEAEE;
            span:nth-child(2) {
              color: #1890FF;
            }
          }
        }
      }
    }
}</style>